// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Zf-z","sponsoredTooltipWrapper":"_f-z","sponsoredTooltip":"ag-z","newCard":"bg-z"};